import { render } from "./InspectorPanel.vue?vue&type=template&id=5d3d6cd2&scoped=true"
import script from "./InspectorPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorPanel.vue?vue&type=script&setup=true&lang=js"

import "./InspectorPanel.vue?vue&type=style&index=0&id=5d3d6cd2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3d6cd2"],['__file',"src/pages/scada/InspectorPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d3d6cd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d3d6cd2', __exports__)) {
    console.log('reload')
    api.reload('5d3d6cd2', __exports__)
  }
  
  module.hot.accept("./InspectorPanel.vue?vue&type=template&id=5d3d6cd2&scoped=true", () => {
    console.log('re-render')
    api.rerender('5d3d6cd2', render)
  })

}


export default __exports__